import { Api } from './Api';


export function* getCities(city){
    const jsonData = yield Api.get(`/regions/sst/q:${city}`);
    return jsonData;
}